
<template>
    <v-container class="grey lighten-5">
        <!-- >>> Resource was chosen: -------------------------------------- -->
        <v-row no-gutters v-if="get_flights_ResourceDetails_ResourceAskedFor.idResource !== undefined">
            <v-col cols="12">
                <v-data-table
                    :items="get_flights_ResourceDetails_TrainingsList"
                    :headers="headers"
                    :fixed-header="true"
                    :sort-by="['name', 'code']"
                    :sort-desc="false"
                    no-data-text="No infos available"
                    :disable-pagination="true"
                    :hide-default-footer="true"
                    :height="calcHeight()"
                    style="border-top-right-radius:4px;">


                    <template v-slot:item.validationDate="{ item }">
                        <p style="font-weight:300; margin: 0;">{{ item.validationDate | dayjsUtcDe }}</p>
                    </template>

                    <template v-slot:item.lastCheckDate="{ item }">
                        <p style="font-weight:300; margin: 0;">{{ item.lastCheckDate | dayjsUtcDe }}</p>
                    </template>

                    <template v-slot:item.validUntilDate="{ item }">
                        <p style="font-weight:300; margin: 0;">{{ item.validUntilDate | dayjsUtcDe }}</p>
                    </template>

                    <template v-slot:item.trafficlight="{ item }">
                        <v-chip
                            :color="getColorForTrafficLight(item)"
                            dark>
                        </v-chip>
                    </template>

                    <template v-slot:item.nextCheckStartDate="{ item }">
                        <p style="font-weight:300; margin: 0;">{{ item.nextCheckStartDate | dayjsUtcDe }}</p>
                    </template>

                    <template v-slot:item.nextCheckEndDate="{ item }">
                        <p style="font-weight:300; margin: 0;">{{ item.nextCheckEndDate | dayjsUtcDe }}</p>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <!-- <<< Resource was chosen: -------------------------------------- -->




        <!-- >>> Resource was not chosen yet: ------------------------------ -->
        <v-row v-if="get_flights_ResourceDetails_ResourceAskedFor.idResource === undefined">
            <v-col cols="12">
                <v-card class="pa-2" style="background-color: #fff;">
                    <v-card-title class="pa-4" style="color: #CB67A0; font-size: 15px; font-weight: 500;">
                        <i style="font-size:20px; color: #A4C2A5;" class="b-fa b-fa-check-circle"></i> Attention: Dear User, first select a resource in the upper area (click checkbox).
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
        <!-- <<< Resource was not chosen yet: ------------------------------ -->
    </v-container>
</template>

<script>
    import Vue from 'vue';
    import { mapGetters, mapActions } from 'vuex';
    import dayjs from 'dayjs';


    export default {
        name: 'Step6Content',

        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_flights_ResourceDetails_TrainingsList',
                'get_flights_ResourceDetails_ResourceAskedFor',
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                // >>> CrewDetails ------------------------
                headers: [
                    {
                        text: 'Name:',
                        align: 'start',
                        sortable: false,
                        value: 'name',
                        class: 'sticky-header grey lighten-4'
                    },
                    {
                        text: 'Code:',
                        align: 'center',
                        sortable: false,
                        value: 'code',
                        class: 'sticky-header grey lighten-4'
                    },
                    {
                        text: 'Sectors:',
                        align: 'center',
                        sortable: false,
                        value: 'sectors',
                        class: 'sticky-header grey lighten-4'
                    },
                    {
                        text: 'Duration:',
                        align: 'center',
                        sortable: false,
                        value: 'duration',
                        class: 'sticky-header grey lighten-4'
                    },
                    {
                        text: 'Unlimited:',
                        align: 'center',
                        sortable: false,
                        value: 'unlimited',
                        class: 'sticky-header grey lighten-4'
                    },
                    {
                        text: 'Vld.months:',
                        align: 'center',
                        sortable: false,
                        value: 'validationMonths',
                        class: 'sticky-header grey lighten-4'
                    },
                    {
                        text: 'Vld.days:',
                        align: 'center',
                        sortable: false,
                        value: 'validationDays',
                        class: 'sticky-header grey lighten-4'
                    },
                    {
                        text: 'Vld.date:',
                        align: 'center',
                        sortable: false,
                        value: 'validationDate',
                        class: 'sticky-header grey lighten-4'
                    },
                    {
                        text: 'Last Check:',
                        align: 'center',
                        sortable: false,
                        value: 'lastCheckDate',
                        class: 'sticky-header grey lighten-4'
                    },
                    {
                        text: 'Valid until:',
                        align: 'center',
                        sortable: false,
                        value: 'validUntilDate',
                        class: 'sticky-header grey lighten-4'
                    },
                    {
                        text: '',
                        align: 'center',
                        width: '70',
                        sortable: false,
                        value: 'trafficlight',
                        class: 'sticky-header grey lighten-4'
                    },
                    {
                        text: 'Next Check Start:',
                        align: 'center',
                        sortable: false,
                        value: 'nextCheckStartDate',
                        class: 'sticky-header grey lighten-4'
                    },
                    {
                        text: 'Next Check End:',
                        align: 'center',
                        sortable: false,
                        value: 'nextCheckEndDate',
                        class: 'sticky-header grey lighten-4'
                    },
                    {
                        text: 'Notes:',
                        align: 'start',
                        sortable: false,
                        value: 'notes',
                        class: 'sticky-header grey lighten-4'
                    },
                ],
            };

        }, // eo data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * getColorForTrafficLight()
            *
            * Desc:
            * Note: Rot = Training abgelaufen (Valid until date in der Vergangenheit)
            * Note: Grün= Training aktiv (Valid until date weit in der Zukunft)
            * Note:
            * Note:
            *
            */
            getColorForTrafficLight: function (item) {

                let me = this,
                    diff = null,
                    formatted = null,
                    color = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/Step6Content.vue >>> getColorForTrafficLight');
                if (item.validUntilDate !== null) {
                    formatted = item.validUntilDate.substring(0,10);
                }
                diff = Math.floor((new Date(formatted) - new Date()) / 86400000);


                if (item.unlimited === true) {
                    if (Vue.prototype.$isEmpty(item.lastCheckDate)) {
                        color = '#ff0000'; // always red
                    }

                    if (!Vue.prototype.$isEmpty(item.lastCheckDate)) {
                        color = '#A4C2A5'; // always green
                    }
                }

                if (item.unlimited === false) {
                    if (diff < 0) {
                        color = '#ff0000';
                    } else if (diff < 60) {
                        color = '#ffa726';
                    } else if (diff > 60 && diff < 84) {
                        color = '#ffff00';
                    } else if (diff > 84) {
                        color = '#A4C2A5';
                    }
                }


                return color;

            }, // eo function getColorForTrafficLight()


            /*******************************************************************
            * calcHeight()
            *
            * Desc:
            * Note:
            * TODO: Height does not work at all.
            *
            */
            calcHeight: function() {

                let me = this,
                    height = 485;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/Step6Content.vue >>> getColorForTrafficLight');
                return +height;

            }, // eo function calcHeight()

        }, // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .v-chip.v-size--default {
        height: 16px !important;
    }

    .v-chip {
        padding: 0 8px !important;
    }
</style>

<style>
    .v-stepper__content {
        padding: 0px 0px 0px 0px !important; /* Really ? */

    }
</style>
